import * as yup from "yup";
import { getText } from "core/utils/getContentText";
import { InputAdornment } from "@mui/material";
import dayjs from "dayjs";
import { DATE_FORMAT } from "constants/appConstants";
import {
  fieldsValidation,
  formatNumber,
  getRawNumberValue,
} from "core/utils/localizationUtils";
import { formatProjectLabel } from "core/utils/appUtils";

const getTextContent = (key) => getText(`projects.addProject.${key}`);

const addProjectValidationSchema = yup.object({
  propertyId: yup
    .string("Select Property For Project")
    .required("Property is required"),
  interiorArea: fieldsValidation.number("Interior Area").nullable(),
  projectEstimatedCost: fieldsValidation
    .number("Estimated Cost")
    .required("Project Estimated cost is required"),
  projectStatusId: yup.string("Select Stage").required("Stage is required"),
  projectType: yup
    .string("Type of Project")
    .required("Project type is required"),
  plannedStartDate: yup
    .date()
    .required("Planned Start Date is required")
    // .nullable()
    .typeError("Enter a valid Start Date"),
  plannedEndDate: yup
    .date()
    .required("Planned Start Date is required")
    // .nullable()
    .typeError("Enter a valid End Date")
    .min(
      yup.ref("plannedStartDate"),
      "Planned End Date can't be before Start Date"
    ),
  warrantyStartDate: yup
    .date()
    .nullable()
    .typeError("Enter a valid Warranty Start Date"),
  warrantyEndDate: yup
    .date()
    .nullable()
    .typeError("Enter a valid End Date")
    .min(
      yup.ref("warrantyStartDate"),
      "Warranty End Date can't be before Start Date"
    ),
});

export const addProjectFields = {
  propertyInformation: [
    {
      key: "projectName",
      label: getTextContent("name"),
      placeholder: "Project Name",
      type: "text",
      width: "50%",
    },
    {
      key: "projectSupervisor",
      label: "Supervisor",
      placeholder: "Select From List",
      type: "dynamicField",
      value: "",
      select: true,
      options: [""],
      width: "50%",
    },
    {
      key: "interiorArea",
      label: "Interior Area (Sq.Ft)",
      placeholder: "Enter Construction Area",
      type: "text",
      width: "50%",
      customValue: formatNumber,
      extraInputProps: (formik) => ({
        onChange: (e) => {
          const validValue = getRawNumberValue(e.target.value);
          formik.setFieldValue("interiorArea", validValue);
        },
      }),
    },
    {
      key: "projectEstimatedCost",
      label: "Estimated Cost",
      customValue: formatNumber,
      placeholder: "Enter Estimated cost in USD",
      type: "text",
      required: false,
      width: "50%",
      extraInputProps: (formik) => ({
        onChange: (e) => {
          const validValue = getRawNumberValue(e.target.value);
          formik.setFieldValue("projectEstimatedCost", validValue);
        },
        InputProps: {
          startAdornment: (
            <InputAdornment position="start">{"$"}</InputAdornment>
          ),
        },
      }),
    },
    {
      key: "projectStatusId",
      label: formatProjectLabel(getTextContent("stage")),
      placeholder: "Select Stage",
      type: "select",
      value: "Contracted",
      select: true,
      options: [],
      required: true,
      width: "50%",
    },

    {
      key: "projectType",
      label: "Type",
      placeholder: "Type of Construction",
      type: "select",
      select: true,
      options: ["New Build", "Renovation", "Remodel", "Tear Down Rebuild"],
      required: true,
      width: "50%",
    },
    {
      key: "plannedStartDate",
      placeholder: DATE_FORMAT,
      label: "Planned Start Date",
      type: "dateField",
      required: true,
      width: "50%",
    },
    {
      key: "plannedEndDate",
      placeholder: DATE_FORMAT,
      label: "Planned End Date",
      type: "dateField",
      width: "50%",
      required: true,
      extraInputProps: (formValues) => ({
        disablePast: true,
        disabled: !formValues.values["plannedStartDate"],
        minDate: dayjs(formValues.values["plannedStartDate"]).add(0, "day"),
        openTo: "day",
      }),
    },
    {
      key: "projectNotes",
      label: "Notes",
      placeholder: "Enter Notes here",
      type: "textArea",
      width: "100%",
      extraInputProps: {
        multiline: true,
        className:
          "registration-formField project-notes property-details-textarea",
      },
    },
    {
      key: "warrantyStartDate",
      placeholder: "MM/DD/YYYY",
      label: "Warranty Start Date",
      type: "dateField",
      width: "50%",
    },
    {
      key: "warrantyEndDate",
      placeholder: "MM/DD/YYYY",
      label: "Warranty End Date",
      type: "dateField",
      width: "50%",
      extraInputProps: (formValues) => ({
        disablePast: true,
        disabled: !formValues.values["warrantyStartDate"],
        minDate: dayjs(formValues.values["warrantyStartDate"]).add(0, "day"),
        openTo: "day",
      }),
    },
  ],
};

export const addProjectForm = {
  validationSchema: addProjectValidationSchema,
  defaultState: (defaultState) => {
    const initialState = Object.fromEntries(
      Object.keys(addProjectValidationSchema.fields).map((key) => {
        return [key, ""];
      })
    );
    if (defaultState) {
      return { ...initialState, ...defaultState };
    }
    return {
      ...initialState,
    };
  },
};
